import { Info } from 'lucide-react';
import { TooltipContent, TooltipTrigger } from './shadcn/tooltip';

interface Props {
  children: React.ReactNode;
}

export function InfoLabelTooltipTrigger({ children }: Props) {
  return (
    <div className="flex justify-start items-center gap-2">
      {children}
      <TooltipTrigger>
        <Info className="text-primary" size={18} />
      </TooltipTrigger>
    </div>
  );
}

export function InfoLabelTooltipContent({ children }: Props) {
  return (
    <TooltipContent>
      <div className="w-[300px] py-1 px-2 flex flex-col gap-2">{children}</div>
    </TooltipContent>
  );
}
